// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2021":"78c050771bd0d366","4353":"b88bfcfa16c7c838","5972":"9b1894a920120066","6370":"5e8437e80bf4153b"}[chunkId] + ".js";
};